import React from "react";
import PropTypes from "prop-types";
import { withApollo } from "react-apollo";

class ErrorThrower extends React.Component {
  componentDidMount() {
    this.props.client.writeData({ data: { error: this.props.status } });

    if (this.props.error) { 
      throw this.props.error;
    } else {
      throw new Error();
    }
  }

  render() {
    return null;
  }
}

ErrorThrower.propTypes = {
  client: PropTypes.shape({
    writeData: PropTypes.func.isRequired,
  }).isRequired,
  error: PropTypes.instanceOf(Error),
  status: PropTypes.number,
};

export default withApollo(ErrorThrower);
